import type { UseQueryResult } from '@edreamsodigeo/frontend-api-client';
import { useQuery } from '@edreamsodigeo/frontend-api-client';
import { USER_INFO_QUERY } from 'clientState/providers/operations/userInfo';
import { UserInfoQueryQuery } from 'generated/graphql';

const useUserInfoQuery = (): UseQueryResult<UserInfoQueryQuery> => {
  return useQuery(USER_INFO_QUERY, {});
};

export default useUserInfoQuery;
